import * as React from 'react';
export const demopaySvg = React.forwardRef(function demopaySvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8 16a8 8 0 0 0 7.5-8A8 8 0 0 0 8 0v2.1c2.1.3 3.3 1.6 3.5 3.2v.2H9.2v-.1C9.1 4.6 8.2 4 7.1 4c-1.2 0-2 .5-2 1.4C5 6 5.6 6.6 7 6.8l1.2.3c2.4.5 3.5 1.4 3.5 3.2 0 2-1.4 3.3-3.7 3.6v2Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M7.5 16H2c-.8 0-1.5-.7-1.5-1.5v-13C.5.7 1.2 0 2 0h3.8v2.2C4 2.6 2.7 3.8 2.7 5.6c0 1.7 1 2.8 3.4 3.2l1.2.3c1.4.3 2 .7 2 1.4 0 .9-.9 1.5-2.2 1.5-1.3 0-2.3-.6-2.3-1.4H2.4c.2 1.7 1.4 2.9 3.4 3.2V16h1.7Z',
    }),
  );
});
demopaySvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var demopay = {
  category: 'paymentmethod',
  colorable: true,
  name: 'demopay',
  svg: demopaySvg,
};
